__turbopack_context__.v({
  "remixSlideDown": "RemixedCardFlyout-module-scss-module__pfhYsa__remixSlideDown",
  "remixSlideLeft": "RemixedCardFlyout-module-scss-module__pfhYsa__remixSlideLeft",
  "remixSlideRight": "RemixedCardFlyout-module-scss-module__pfhYsa__remixSlideRight",
  "remixSlideUp": "RemixedCardFlyout-module-scss-module__pfhYsa__remixSlideUp",
  "slideDown": "RemixedCardFlyout-module-scss-module__pfhYsa__slideDown",
  "slideLeft": "RemixedCardFlyout-module-scss-module__pfhYsa__slideLeft",
  "slideRight": "RemixedCardFlyout-module-scss-module__pfhYsa__slideRight",
  "slideUp": "RemixedCardFlyout-module-scss-module__pfhYsa__slideUp",
  "tile": "RemixedCardFlyout-module-scss-module__pfhYsa__tile",
});
